module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "content-a",
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ebook_split_006#_idF123"
    }
  }, [_vm._v("Foreword")]), _c('a', {
    attrs: {
      "id": "_idTextF123"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ebook_split_006#_idTextAnchor029"
    }
  }, [_vm._v("Preface")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ebook_split_007#_idTextAnchor030"
    }
  }, [_vm._v("Prologue")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ebook_split_008#_idTextAnchor031"
    }
  }, [_vm._v("Chapter 1: A New Life")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_009#_idTextAnchor032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: The Lioness Within")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_010#_idTextAnchor033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Broken Boundaries, Broken Trust")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_011#_idTextAnchor034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Taking Charge: Tallahassee, Florida,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("The Governor’s Chambers")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_012#_idTextAnchor035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Dreams Fulfilled")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_013#_idTextAnchor036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Walls Begin to Crumble")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_014#_idTextAnchor037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Affair")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_015#_idTextAnchor038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Preparing and the Day")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_016#_idTextAnchor039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The House Falls Down")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_017#_idTextAnchor040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Complicated Grief")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_018#_idTextAnchor041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Gifts to Heal")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_019#_idTextAnchor042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Something New")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_020#_idTextAnchor043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Meeting the Wizard")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_021#_idTextAnchor044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Crossing New Thresholds")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_022#_idTextAnchor045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Destiny Unfolds")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_023#_idTextAnchor046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: The Ruse")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_024#_idTextAnchor047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Things Go Wonky—Back in Oz")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_025#_idTextAnchor048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Sharing")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_026#_idTextAnchor049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: A New Era of Medicine")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_027#_idTextAnchor050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Dark Entities")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_028#_idTextAnchor051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Endings Bring New Life")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_029#_idTextAnchor052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Another Test")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_030#_idTextAnchor053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The Cause Becomes the Cure")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_031#_idTextAnchor054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: True Wizardry")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_032#_idTextAnchor055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Coming Home")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_033#_idTextAnchor056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P.S.")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_034#_idTextAnchor057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ebook_split_035#a02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "a01"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_11"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b7720c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_005.vue
// module id = 75
// module chunks = 0